import 'react-datepicker/dist/react-datepicker.css'
import './react-datepicker.scss'

import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import { format, getYear } from 'date-fns'
import React, { useState } from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'

import Button from '@/components-latest/primitives/Button'
import CircularButton from '@/components-latest/primitives/CircularButton'
import Text from '@/components-latest/primitives/Text'

import Styles from './Calendar.module.scss'

interface CalendarProps extends ReactDatePickerProps {
  onChange: (date: Date | null) => void
  date: Date | null
}

const Calendar: React.FC<CalendarProps> = ({
  onChange,
  date,
  ...restProps
}) => {
  const [viewMode, setViewMode] = useState<'date' | 'year'>('date')

  const renderHeader: ReactDatePickerProps['renderCustomHeader'] = ({
    date,
    increaseMonth,
    increaseYear,
    decreaseMonth,
    decreaseYear
  }) => {
    switch (viewMode) {
      case 'date':
        return (
          <div className={Styles.dateHeader}>
            <CircularButton
              data-testid="calendar-prev-button"
              variant="flat"
              size="normal"
              onClick={decreaseMonth}>
              <ChevronLeftIcon />
            </CircularButton>
            <div className={Styles.headerDateContainer}>
              <Button
                data-testid="calendar-year-button"
                className={Styles.headerDate}
                onClick={() => setViewMode('year')}>
                <Text variant="nextSubtitle">
                  {getYear(date)} {format(date, 'MMMM')}
                </Text>
              </Button>
            </div>
            <CircularButton
              data-testid="calendar-next-button"
              variant="flat"
              size="normal"
              onClick={increaseMonth}>
              <ChevronRightIcon />
            </CircularButton>
          </div>
        )
      case 'year':
        return (
          <div className={Styles.dateHeader}>
            <CircularButton
              data-testid="calendar-prev-button"
              variant="flat"
              size="normal"
              onClick={decreaseYear}>
              <ChevronLeftIcon />
            </CircularButton>
            <div className={Styles.headerDateContainer}>
              <Button
                data-testid="calendar-date-button"
                className={Styles.headerDate}
                onClick={() => setViewMode('date')}>
                <Text variant="nextSubtitle">{getYear(date)}</Text>
              </Button>
            </div>
            <CircularButton
              data-testid="calendar-next-button"
              variant="flat"
              size="normal"
              onClick={increaseYear}>
              <ChevronRightIcon />
            </CircularButton>
          </div>
        )
      default:
        return null as never
    }
  }

      return (
        // @ts-ignore
        <DatePicker
      selected={date}
      onChange={onChange}
      renderCustomHeader={renderHeader}
      showMonthYearPicker={viewMode === 'year'}
      dateFormat="MM/yyyy"
      inline
      {...restProps}
    />
  )
}

export default Calendar
